module.exports = __webpack_public_path__ + "img/E2-topImg-m.6ba42bfd.png";